import { useSectionContent } from "./useSectionContent";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, Activity, TreePine, MapPin, BookOpen, Sparkles, Users, ShieldCheck, Wind } from "lucide-react";
import api from "@/lib/api";
import CountUp from "@/components/motion/CountUp";
import { useSite } from "@/contexts/SiteContext";
import { useAuth } from "@/contexts/AuthContext";


/* Secțiuni noi de homepage (Dim 15). Fiecare e o secțiune CMS (visible din live editor). */


/* ── 15.28 Evenimentele care urmează (gratuite/live) ── */
export function HomeEvents() {
  const c = useSectionContent("home_events");
  const [events, setEvents] = useState([]);
  useEffect(() => {
    api.get("/public/events").then((r) => {
      const today = new Date().toISOString().slice(0, 10);
      const list = (Array.isArray(r.data) ? r.data : []).filter((e) => (e.event_date || e.date || "") >= today)
        .sort((a, b) => (a.event_date || a.date || "").localeCompare(b.event_date || b.date || "")).slice(0, 3);
      setEvents(list);
    }).catch(() => {});
  }, []);
  if (events.length === 0) return null;
  return (
    <section className="py-14" style={{ background: "var(--ct-surface)" }}>
      <div className="max-w-3xl mx-auto px-5">
        <div className="text-center mb-8">
          <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Ce urmează"}</span>
          <h2 data-el="title" data-field="title" className="font-serif text-3xl sm:text-4xl mt-2">{c.title || "Întâlniri live cu Georgiana"}</h2>
        </div>
        <div className="space-y-3">
          {events.map((e) => (
            <Link key={e.id} to="/live" className="card-premium p-5 flex items-center justify-between gap-4 hover:-translate-y-0.5 transition-transform" data-testid={`home-event-${e.id}`}>
              <div>
                <p data-el="item_title" className="text-sm font-medium">{e.title}</p>
                <p data-el="item_body" className="text-xs mt-0.5" style={{ color: "var(--ct-text-dim)" }}>{e.event_date || e.date}{e.event_time ? ` · ${e.event_time}` : ""}</p>
              </div>
              <ArrowRight size={16} style={{ color: "var(--ct-gold)" }} />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
